// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "style/2c1forest/" + chunkId + ".bundle.css";
};